/**
 * "City, ST" for a school, tolerating a missing city. Some imported schools
 * have no city on record, and interpolating one blindly renders ", CA".
 */
export function formatCityState(
  city: string | null | undefined,
  state: string | null | undefined
): string {
  return [city, state]
    .map(part => (part ?? '').trim())
    .filter(Boolean)
    .join(', ')
}
